export default "__VITE_ASSET__DDlyMggE__"